"use strict";

function callModal(dataModal) {
    
    var modalDiv = $('#js-message');
    modalDiv.find('.modal-title').html(dataModal['header']);
    modalDiv.find('.modal-body').html(dataModal['body']);
    modalDiv.find('.modal-footer').html(dataModal['footer']);
    modalDiv.modal();

}

function scrollWindow(id, speed) {
    var page = $("html, body");

    var header = 0;

    page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function () {
        page.stop();
    });

    page.animate({scrollTop: $(id).offset().top - header}, speed, function () {
        page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
    });

}


function findBigHeight(id){

    var eventHeight = [];
    $(id).each(function(index, el) {
        eventHeight.push(parseInt($(el).height())); 

    });
    eventHeight = eventHeight.sort(function(a, b){return b-a;});
    return eventHeight[0];

}

function setHeightEvent(id){


    $(id).height(findBigHeight(id));
    //$(id).css('min-height', findBigHeight(id));
}



$(function() {
    $('.js-map').click(function() {
        $(this).find('iframe').toggleClass('scroll-off');
    });
    $('.js-map').on("mouseleave", function() {

        $(this).find('iframe').addClass('scroll-off');
    });
});




$(function() {
    $(document).on('click', '#__bs_notify__', function(event) {
        event.preventDefault();
        $(this).remove(); /* Act on the event */
    }); 
});


$(function () {
    $(document).on("click", ".js-copy-lang-ckeditor", function () {
        event.preventDefault();
 
        var p = CKEDITOR.instances[$(this).attr('data-selector-target')].getData();
        if (p) {

            if (confirm('Přejete si přepsat aktuální text ?')) {
                CKEDITOR.instances[$(this).data('selector-target')].setData(CKEDITOR.instances[$(this).data('selector-source')].getData());
            }
        } else {
            CKEDITOR.instances[$(this).data('selector-target')].setData(CKEDITOR.instances[$(this).data('selector-source')].getData());
        }


        return false;
    });
})

$(function () {
    $(document).on("click", ".js-copy-lang", function () {
        event.preventDefault();

        var p =  $('#'+$(this).attr('data-selector-target')).val();
        
        if (p) {
            if (confirm('Přejete si přepsat aktuální text ?')) {
                 console.log($('#'+$(this).attr('data-selector-source')).val());
                 $('#'+$(this).attr('data-selector-target')).val(   $('#'+$(this).attr('data-selector-source')).val());
            }
        } else {
             $('#'+$(this).attr('data-selector-target')).val(   $('#'+$(this).attr('data-selector-source')).val());
        }


        return false;
    });
})